/**
 * WordPress dependencies
 * @wordpress/i18n for translation functions
 * - https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 * - Should basically always be used for any text that is visible to the user
 *
 * @wordpress/element for React components
 * - https://developer.wordpress.org/block-editor/reference-guides/packages/packages-element/
 */
// import CourseListItem from './CourseListItem';
import { __ } from '@wordpress/i18n';
import { decodeEntities } from '@wordpress/html-entities';

/**
 * Check item status
 * - If it has at least one confirmed instance, return 'confirmed'
 * - If it has no confirmed instances, but at least one planned instance, return 'planned'
 * - If it has no confirmed or planned instances, return 'on demand'
 *
 * @param {Array} instances Array of event instances
 * @return {string} Status of the item
 */
const itemStatus = (instances) => {
	if (!instances || instances.length === 0) {
		return 'On Demand';
	}

	if (
		instances.some((instance) =>
			instance.status.some((status) => status.slug === 'confirmed')
		)
	) {
		return 'Confirmed';
	}

	if (
		instances.some((instance) =>
			instance.status.some((status) => status.slug === 'planned')
		)
	) {
		return 'Planned';
	}

	return 'On Demand';
};

/**
 * Example Component
 * @returns {JSX.Element}
 */
function CourseListItemStatus({ instances }) {
	console.log('CourseListItemStatus instances:', instances);
	return (
		<div className="course-list-item__status">
			<span className="course-list-item__status-item">
				{itemStatus(instances)}
			</span>
		</div>
	);
}

export default CourseListItemStatus;
